import { createStyles, InputBase, makeStyles, Theme } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useBaseStyles = makeStyles(
  (theme) => ({
    root: {
      "& label": {
        display: "block",
        color: (prop: any) =>
          !prop.error ? theme.palette.text.primary : theme.palette.error.main,
        fontWeight: 500,
        fontSize: 13,
        padding: 0,
        textAlign: "left",
        cursor: "pointer",
      },

      "& .MuiSelect-icon": {
        right: 12,
        color: (prop: any) =>
          !prop.error ? theme.palette.text.primary : theme.palette.error.main,
        top: "calc(28%)",
      },
    },
  }),
  {}
);

export const useSelectStyles = makeStyles(
  (theme) => ({
    select: {
      "&.MuiPaper-elevation8": {
        boxShadow: theme.shadows[1],
      },

      "&.Mui-disabled": {
        backgroundColor: "#fcfcfb",
      },

      "& ul": {
        backgroundColor: theme.palette.common.white,
      },
      "& li": {
        backgroundColor: theme.palette.common.white,
        fontSize: 14,
        "&:hover": {
          backgroundColor: "#F5F5F5",
        },
        "&.Mui-selected": {
          backgroundColor: "#F5F5F5",
          "&:hover": {
            backgroundColor: "#F5F5F5",
          },
        },
      },
    },
  }),
  {}
);

export const SelectBaseInput = withStyles((theme: Theme) =>
  createStyles({
    root: {},
    input: {
      borderRadius: 2,
      position: "relative",
      backgroundColor: theme.palette.common.white,
      border: (prop: any) =>
        !prop.error
          ? `1px solid ${defaultBorder(theme)}`
          : `1px solid ${theme.palette.error.main}`,
      fontSize: 14,
      paddingTop: 10,
      paddingBottom: 11,
      paddingLeft: 14,
      paddingRight: 14,
      textAlign: "left",
      color: (prop: any) =>
        !prop.error ? theme.palette.text.primary : theme.palette.error.main,
      transition: theme.transitions.create([
        "border-color",
        "background-color",
      ]),

      "&:focus": {
        backgroundColor: theme.palette.common.white,
      },

      "&:hover": {
        backgroundColor: "#fcfcfb",
      },
    },
  })
)(InputBase);

export const useHelperTextStyles = makeStyles(
  (theme) => ({
    root: {
      color: "red",
      fontSize: 14,
      margin: "4px 2px",
    },
  }),
  {}
);
